"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = _default;

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _loadScript = _interopRequireDefault(require("./loadScript"));

function _default() {
  if (window.UIG_CDN_React_16_8) {
    return _promise.default.resolve();
  }

  return (0, _loadScript.default)("https://cld1.staticsfly.com/react168.52da12f486.js");
}

//# sourceMappingURL=react_16_8.js.map